var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("Players")]),_c('div',[_c('PlayersTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }